<template>
    <div id="catalog2">
        <Header
            :colors="colors"
            :disableUserListToggle="disableUserListToggle"
            :imageUrl="titleImageUrl"
            :is-help-desk="true"
            :is-root-catalog="isRootCatalog"
            :onClose="onClose"
            :participants="participants"
            :showCloseButton="showCloseButton"
            :title="title"
            @back-to-parent="backToParent"
            :ticket-mode="false"
        >
        </Header>
        <div class="catalog-content-wrapper">
            <div v-if="!isContentLastChild" class="catalog-list">
                <div class="catalog-content-class">
                    <div class="d-flex justify-content-between w-100">
                        <div style="width: 40px">
                            <md-button
                                v-if="!isRootCatalog"
                                class="md-icon-button"
                                style="margin: 3px"
                                @click="backToParent"
                            >
                                <md-icon style="color: var(--color7)">navigate_before</md-icon>
                            </md-button>
                        </div>
                        <h4 class="main-text-color" style="flex: 1; text-align: center">
                            {{ getTitle() }}
                        </h4>
                        <div style="width: 40px" />
                    </div>

                    <div class="" style="width: 100%" v-for="c in content">
                        <md-button class="catalog-content-name catalog-button" @click="getChildren(c)">
                            {{ c.languageContent[$i18n.locale].name }}
                        </md-button>
                    </div>
                </div>
            </div>
            <div v-else class="catalog-rating-class">
                <div class="d-flex justify-content-between w-100">
                    <div style="width: 40px">
                        <md-button class="md-icon-button" style="margin: 3px" @click="backToParent">
                            <md-icon style="color: var(--color7)">navigate_before</md-icon>
                        </md-button>
                    </div>
                    <h4 class="main-text-color" style="flex: 1; text-align: center">
                        {{ content[0].languageContent[$i18n.locale].name }}
                    </h4>
                    <div style="width: 40px" />
                </div>
                <div v-html="content[0].languageContent[$i18n.locale].content" class="catalogContent"></div>
                <div v-if="isContentLastChild && !isRated">
                    <div class="catalog-rating-help">{{ $t("message.didHelpful") }}</div>
                    <md-button class="d-icon-button md-raised" @click="rateContent(1)">{{
                        $t("message.yes")
                    }}</md-button>
                    <md-button class="d-icon-button md-raised" @click="rateContent(0)">{{
                        $t("message.no")
                    }}</md-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { log2 } from "../../utils/log2";
import Header from "./popup-chat/Header";
import _ from "lodash";
import {increaseViewCatalog} from "../../api/catalog"

const log = log2("Rate");
export default {
    name: "Catalog",
    data() {
        return {
            loading: false,
            currentRate: null,
            isRootCatalog: true,
            navigator: [],
            isRated: false,
        };
    },
    components: {
        Header,
    },
    props: {
        showCloseButton: {
            type: Boolean,
            default: true,
        },
        participants: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            default: "Help Center",
            required: false,
        },
        titleImageUrl: {
            type: String,
            default: "",
        },
        onClose: {
            type: Function,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        disableUserListToggle: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            content: (state) => state.catalog.content,
            isContentLastChild: (state) => state.catalog.isContentLastChild,
            settings: (state) => state.setting.settings,
        }),
    },
    methods: {
        ...mapActions({
            getMainCategories: "catalog/getCategories",
            getContentChildren: "catalog/getChildren",
            ratingAction: "catalog/rateContent",
            setContent: "catalog/setContent",
            setIsLastChild: "catalog/setIsLastChild",
        }),
        getChildren(c) {
            log("console log is here for catalog", c);
            this.navigator.push(_.cloneDeep(c));
            if (c.type === "content") {
                increaseViewCatalog(c._id);
                this.setContent(c);
                this.setIsLastChild(true);
            } else {
                this.getContentChildren(c._id);
                this.setIsLastChild(false);
            }
            this.isRootCatalog = false;
        },
        backToParent() {
            log("back to parent");
            if (this.navigator[this.navigator.length - 1].parentId) {
                log("parent id is here ", this.navigator[this.navigator.length - 1]);
                this.getContentChildren(this.navigator[this.navigator.length - 1].parentId);
                this.navigator.pop();
                this.isRootCatalog = false;
                this.isRated = false;
                this.setIsLastChild(false);
            } else {
                this.getMainCategories();
                this.navigator.pop();
                this.isRootCatalog = true;
                this.isRated = false;
                this.setIsLastChild(false);
            }
        },
        rateContent(rate) {
            this.isRated = true;
            if (rate === 1) {
                let id = this.content[0]._id;
                this.ratingAction({ id: id, rate: rate });
            } else {
                let id = this.content[0]._id;
                this.ratingAction({ id: id, rate: 0 });
            }
        },
        getTitle() {
            let maybeCatalog = this.settings.catalogTitle.find((x) => x.languageCode === this.$i18n.locale);
            if (maybeCatalog) {
                return maybeCatalog.content;
            }
            return "Catalog Menu";
        },
    },
    mounted() {
        this.getMainCategories();
    },
};
</script>

<style lang="scss">
.catalog-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    margin: 2px 0;
}

.catalog-card {
    border-radius: 5px;
    margin-top: 15px;
}

.catalogContent {
    width: 100%;
}

#catalog2 {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    .header {
        display: flex;
        color: #fff;
        font-weight: 700;
        font-size: 12px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
        width: 100%;
        top: 0;
        padding: 10px;
    }

    .catalog-content-wrapper {
        width: 100%;
        justify-content: center;
        align-items: center;
        margin: 50px 20px;
        max-height: 75vh;
        overflow-y: scroll;
        &::-webkit-scrollbar {
            display: none;
        }
        .catalog-content-class {
            background-color: transparent;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 6px;

            .catalog-content-name {
                margin-right: 0 !important;
                background-color: white;
                box-shadow: 1px 4px 7px 0px #0000007a;
                width: 98%;
                margin-left: 5px !important;
                margin-bottom: 11px;
            }
        }
        .catalog-info-class {
            margin-top: 50px;
            display: flex;
            flex-direction: column;
        }

        .catalog-rating-class {
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            margin-top: 20px;
            justify-content: center;
            align-items: center;

            .catalog-rating-help {
                font-size: 16px;
                text-align: center;
                color: var(--color7);
            }

            .catalog-rating-button {
                margin-left: 0 !important;
                margin-right: 0 !important;
                margin-top: 20px;
                width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/Catalog.vue